import richText from "utilities/richText"

export default function TwoColumnList({ blok }) {
  return <div className="lg:columns-2">{richText(blok.list)}</div>
}
